import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Switch } from "antd";
import moment from "moment";
import _ from "i18n";

import { DatePicker } from "antd";
import Select from "react-select";
import { CloseIcon } from "../Common/Icons";
import { getUserNameForAvatar } from "Utils";
import { TTP_API_URL } from "Config";
import {
  setPresentationDate,
  setPresentationIsPrepared,
  setPresentationIsPresented,
  setPresentationPresenters
} from "Actions";

import styles from "./PreparePresentation.local.scss";

class PresentationConfig extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedUser: null
    };
  }

  handleDateChange = value => {
    const { dispatch } = this.props;
    dispatch(
      setPresentationDate(!value ? null : value.format("YYYY-MM-DD HH:mm"))
    );
  };

  onChangeIsPrepared = () => {
    const { dispatch, isPrepared } = this.props;
    dispatch(setPresentationIsPrepared(isPrepared ? 0 : 1));
  };

  onChangeIsPresented = () => {
    const { dispatch, isPresented } = this.props;
    dispatch(setPresentationIsPresented(isPresented ? 0 : 1));
  };

  onChangeIsFreezed = () => {
    this.props.onChangeIsFreezed();
  };

  renderConfigBlock = () => {
    const { date, isPrepared, isPresented, isFrozen } = this.props;

    return (
      <div className={styles.config_block}>
        <div className={styles.presentation_date_container}>
          <span className={styles.title}>{_("definePresentationDate")}</span>
          <DatePicker
            className={styles.date_picker}
            showToday={false}
            allowClear={true}
            placeholder={_("selectPresentationDate")}
            onChange={e => this.handleDateChange(e)}
            value={date ? moment(date, "YYYY-MM-DD HH:mm") : null}
            showTime={{ format: "hh:mm A" }}
            format="YYYY-MM-DD HH:mm"
          />
        </div>
        <div className={styles.presentation_date_container}>
          <span className={styles.title}>{_("setPresentationState")}</span>
          <div className={styles.config_check}>
            <div>
              <span className={styles.sub_title}>
                {_("presentationPreparedQuestion")}
              </span>
            </div>
            <Switch
              className={styles.switch}
              checked={isPrepared}
              onChange={() => this.onChangeIsPrepared()}
            />
          </div>
          <div className={styles.config_check}>
            <div>
              <span className={styles.sub_title}>
                {_("presentationPresentedQuestion")}
              </span>
            </div>
            <Switch
              className={styles.switch}
              checked={isPresented}
              onChange={() => this.onChangeIsPresented()}
            />
          </div>
          <div className={styles.config_check}>
            <div>
              <span className={styles.sub_title}>
                {_("presentationFreezedQuestion")}
              </span>
            </div>
            <Switch
              className={styles.switch}
              checked={isFrozen}
              onChange={() => this.onChangeIsFreezed()}
            />
          </div>
        </div>
      </div>
    );
  };

  handleAddPresenter = selectedUser => {
    const { users, presenters, dispatch } = this.props;

    let presentersList = [...presenters];

    if (selectedUser.value !== null) {
      let presenter = users.items.find(item => item.id === selectedUser.value);

      presentersList.push(presenter);

      dispatch(setPresentationPresenters(presentersList));

      this.setState({
        selectedUser: null
      });
    }
  };

  handleRemovePresenter = userId => {
    const { presenters, dispatch } = this.props;

    dispatch(
      setPresentationPresenters(presenters.filter(item => item.id !== userId))
    );
  };

  renderPresentersBlock = () => {
    const { presenters, users } = this.props;
    const { selectedUser } = this.state;

    let usersOptionsSelect =
      users.items &&
      users.items.map(user => {
        const name = `${user.firstName} ${user.lastName}`;
        return { label: name, value: user.id };
      });

    usersOptionsSelect = usersOptionsSelect.filter(
      user => !presenters.find(item => item.id === user.value)
    );

    return (
      <div className={styles.config_block}>
        <div className={styles.presentation_date_container}>
          <span className={styles.title}>{_("addPresenter")}</span>
          <Select
            value={
              this.state.selectedUser &&
              usersOptionsSelect.find(user => user.value === selectedUser)
            }
            onChange={this.handleAddPresenter}
            options={usersOptionsSelect}
            className={classnames("indicators", "presenters_select")}
            classNamePrefix="ttp-select"
            isClearable={true}
            placeholder={"Les collaborateurs..."}
            menuPlacement="auto"
            style={{ margin: "8px 0" }}
          />
          <div className={classnames("row", styles.users)}>
            {presenters.map((presenter, i) => {
              return (
                <div key={"presenter-" + i}>
                  {this.renderUser(
                    presenter.id,
                    presenter.firstName,
                    presenter.lastName,
                    presenter.avatar,
                    presenter.avatarUrl,
                    presenter.role
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  renderUser = (id, firstName, lastName, avatar, avatarUrl, role) => {
    const { currentUser } = this.props;

    return (
      <div className={styles.user} id={"presenter-" + id}>
        {avatarUrl !== undefined ? (
          <div
            className={styles.avatar}
            style={{ backgroundImage: `url(${avatarUrl})` }}
          />
        ) : avatar ? (
          <div
            className={styles.avatar}
            style={{ backgroundImage: `url(${TTP_API_URL}/${avatar})` }}
          />
        ) : (
          <div className={classnames(styles.avatar, "empty-avatar")}>
            <span>{getUserNameForAvatar(firstName, lastName)}</span>
          </div>
        )}

        <span className={styles.user_name}>
          {`${firstName} ${lastName} ${currentUser.id === id ? "(Vous)" : ""}`}
        </span>
        <span className={styles.user_role}>
          {role && role.id !== undefined ? _(role.type) : "____"}
        </span>
        <div onClick={() => this.handleRemovePresenter(id)}>
          <CloseIcon className={styles.user_close} />
        </div>
      </div>
    );
  };

  renderPresentationConfig = () => {
    return (
      <div className={styles.config_container}>
        {this.renderConfigBlock()}
        {this.renderPresentersBlock()}
      </div>
    );
  };

  render() {
    return this.renderPresentationConfig();
  }
}

// Connected Component
const mapStateToProps = state => ({
  date: state.presentation.presentationConfig.date,
  isPrepared: state.presentation.presentationConfig.isPrepared,
  isPresented: state.presentation.presentationConfig.isPresented,
  presenters: state.presentation.presentationConfig.presenters,
  currentUser: state.auth.user,
  users: state.presentation.users
});

export default connect(mapStateToProps)(PresentationConfig);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/PresentationConfig.js